import { h } from "preact";
import { useEffect } from "preact/hooks";
import { route } from "preact-router";
import User from "../../../../services/user";

/**
 * Handles the magic link login process.
 * Extracts the token from the URL, initiates the login,
 * and immediately redirects to the homepage.
 */
export const MagicLinkHandler = (props) => {
	useEffect(() => {
		const token = props.token;

		if (token) {
			// Call tokenLogin asynchronously (fire and forget)
			User.tokenLogin(token)
		}

		// Immediately redirect to the homepage
		// The `true` argument replaces the current history entry
		route("/", true);
	}, []);

	return null;
};
